/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc コンポーネント関連ユーティリティ
 *
 * @author genka
 * @copyright Copyright 2019 TechMatrix Corporation, Inc. All rights reserved.
 */
export default new class {
  /**
   * 対象にコンポーネントがMixinされているか
   * @param  {[type]}  target
   * @param  {[type]}  component
   * @return {Boolean}
   */
  hasMixin(target, component) {
    if (target == null || target.constructor == null || target.constructor.options == null || target.constructor.options.mixins == null) {
      return false
    }
    return target.constructor.options.mixins.some((mixin) => {
      if (mixin === component) {
        return true
      }
    })
  }
}()



// WEBPACK FOOTER //
// ./src/utils/ComponentUtil.js